import React from 'react';
import cn from 'classnames';
import styles from './styles.module.scss';

const H4 = ({ className, ...props }) => (
  <h4 className={cn(styles.h4, className, props.styles)} style={props.style}>
    {props.children}
  </h4>
);

export default H4;
